module.exports = __webpack_public_path__ + "img/TERN.3f0521de.svg";